import { render, staticRenderFns } from "./FeatureBox.vue?vue&type=template&id=1a2d58f6&"
import script from "./FeatureBox.vue?vue&type=script&lang=js&"
export * from "./FeatureBox.vue?vue&type=script&lang=js&"
import style0 from "./FeatureBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports